module.exports = "<v-toggle [disabled]=disabled [value]=hasFlag (onChanged)=onToggled($event)></v-toggle> ";